"use strict";
const movingElement0 = () => {
	/**
	 * when, where, after what (optional)
	 * data-moveto="max-width: 800px, .test3, .test2"
	 */

	const elems = document.querySelectorAll("[data-moveto]");

	if (elems.length > 0) {
		let оbjects = [];
		for (let i = 0; i < elems.length; i++) {
			const dataArray = elems[i].dataset.moveto.split(",");
			const оbject = {};
			оbject.elem = elems[i];
			оbject.parent = elems[i].parentNode;
			оbject.parentDist = elems[i].parentNode.parentNode;
			if (elems[i].previousElementSibling) {
				оbject.sibling = elems[i].previousElementSibling.className;
			}
			оbject.breakpoint = dataArray[0].trim();
			оbject.to = dataArray[1].trim();
			if (dataArray[2]) {
				оbject.after = dataArray[2].trim();
			}
			оbjects.push(оbject);
		}

		for (let i = 0; i < оbjects.length; i++) {
			let wmm = window.matchMedia(`(${оbjects[i].breakpoint})`);
			let sibling;
			оbjects[i].sibling ? sibling = оbjects[i].sibling.split(" ") : sibling = '';
			//let sibling = оbjects[i].sibling.split(" ")
			wmm.addListener(() => {
				if (wmm.matches) {
					if (оbjects[i].after) {
						if (оbjects[i].parentDist && оbjects[i].parentDist.querySelector(оbjects[i].after)) {
							оbjects[i].parentDist.querySelector(оbjects[i].after).insertAdjacentElement('afterend', оbjects[i].elem);

						} else if (оbjects[i].parentDist) {
							оbjects[i].parentDist.querySelector(оbjects[i].to).insertAdjacentElement('afterbegin', оbjects[i].elem);

						} else {
							document.querySelector(оbjects[i].after).insertAdjacentElement('afterend', оbjects[i].elem);

						}

					} else {
						/*if (оbjects[i].parentDist) {
							оbjects[i].parentDist.querySelector(оbjects[i].to).insertAdjacentElement('beforeend', оbjects[i].elem);
						} else {

							document.querySelector(оbjects[i].to).insertAdjacentElement('beforeend', оbjects[i].elem);
						}*/
						document.querySelector(оbjects[i].to).insertAdjacentElement('beforeend', оbjects[i].elem);
					}
				} else {
					if (sibling[0] && sibling[0] != 'undefined') {
						if (оbjects[i].parentDist) {
							оbjects[i].parentDist.querySelector('.' + sibling[0]).insertAdjacentElement('afterend', оbjects[i].elem);
						} else {
							document.querySelector('.' + sibling[0]).insertAdjacentElement('afterend', оbjects[i].elem);
						}
					} else {
						оbjects[i].parent.insertAdjacentElement('afterbegin', оbjects[i].elem);
					}

				}
			});

			if (wmm.matches) {
				if (оbjects[i].after) {
					if (оbjects[i].parentDist && оbjects[i].parentDist.querySelector(оbjects[i].after)) {
						оbjects[i].parentDist.querySelector(оbjects[i].after).insertAdjacentElement('afterend', оbjects[i].elem);
					} else if (оbjects[i].parentDist) {
						оbjects[i].parentDist.querySelector(оbjects[i].to).insertAdjacentElement('afterbegin', оbjects[i].elem);
					} else {
						document.querySelector(оbjects[i].after).insertAdjacentElement('afterend', оbjects[i].elem);
					}
				} else {
					if (оbjects[i].parentDist) {
						//оbjects[i].parentDist.querySelector(оbjects[i].to).insertAdjacentElement('beforeend', оbjects[i].elem);
						document.querySelector(оbjects[i].to).insertAdjacentElement('beforeend', оbjects[i].elem);
					} else {
						document.querySelector(оbjects[i].to).insertAdjacentElement('afterend', оbjects[i].elem);
					}

				}
			}
		}
	}

}
const movingElement1 = () => {
	const elems = document.querySelectorAll("[data-moveto]");
	if (!elems.length) return;

	const items = Array.from(elems).map((elem) => {
		const parts = elem.dataset.moveto.split(",").map((s) => s.trim());
		const marker = document.createComment("data-moveto-marker");
		elem.parentNode.insertBefore(marker, elem);

		return {
			elem,
			marker,
			breakpoint: parts[0],
			to: parts[1],
			after: parts[2] || null,
		};
	});

	const apply = (item, matches) => {
		if (matches) {
			if (item.after) {
				const afterEl = document.querySelector(item.after);
				if (afterEl) {
					afterEl.insertAdjacentElement("afterend", item.elem);
					return;
				}
			}
			const toEl = document.querySelector(item.to);
			if (toEl) toEl.insertAdjacentElement("beforeend", item.elem);
			return;
		}

		if (item.marker.parentNode) {
			item.marker.parentNode.insertBefore(item.elem, item.marker);
		}
	};

	items.forEach((item) => {
		const mql = window.matchMedia(`(${item.breakpoint})`);
		const onChange = (e) => apply(item, e.matches);

		if (typeof mql.addEventListener === "function") {
			mql.addEventListener("change", onChange);
		} else {
			mql.addListener(onChange);
		}

		apply(item, mql.matches);
	});
};
const movingElement = () => {
	const elems = document.querySelectorAll("[data-moveto]");
	if (!elems.length) return;

	const findScoped = (elem, selector) => {
		if (!selector) return null;

		const customScope = elem.dataset.movetoScope;
		if (customScope) {
			const scope = elem.closest(customScope);
			if (scope) return scope.querySelector(selector);
		}

		let node = elem.parentElement;
		while (node) {
			const found = node.querySelector(selector);
			if (found) return found;
			node = node.parentElement;
		}

		return null;
	};

	const items = Array.from(elems).map((elem) => {
		const parts = elem.dataset.moveto.split(",").map((s) => s.trim());
		const marker = document.createComment("data-moveto-marker");
		elem.parentNode.insertBefore(marker, elem);

		return {
			elem,
			marker,
			breakpoint: parts[0],
			to: parts[1],
			after: parts[2] || null,
		};
	});

	const apply = (item, matches) => {
		if (matches) {
			if (item.after) {
				const afterEl = findScoped(item.elem, item.after);
				if (afterEl) {
					afterEl.insertAdjacentElement("afterend", item.elem);
					return;
				}
			}

			const toEl = findScoped(item.elem, item.to);
			if (toEl) toEl.insertAdjacentElement("beforeend", item.elem);
			return;
		}

		if (item.marker.parentNode) {
			item.marker.parentNode.insertBefore(item.elem, item.marker);
		}
	};

	items.forEach((item) => {
		const mql = window.matchMedia(`(${item.breakpoint})`);
		const onChange = (e) => apply(item, e.matches);

		if (typeof mql.addEventListener === "function") {
			mql.addEventListener("change", onChange);
		} else {
			mql.addListener(onChange);
		}

		apply(item, mql.matches);
	});
};

movingElement();